import { cn } from '@/lib/utils'

/**
 * The portal's mark: a rising bar chart in a rounded square — the accelerator's
 * whole premise, which is that the numbers move.
 *
 * Colors come from the Don't Panic Labs palette: the vivid brand green as the
 * fill, navy ink for the bars (6.04:1). Deliberately NOT white-on-green — brand
 * green is only 2.62:1 against white.
 *
 * This is a stand-in, not DPL's logo. To use the real one, drop
 * `DPL-full-color-2-o.svg` into `web/public/` and swap this component out — note
 * it's a 225×116 wordmark, so the sidebar and sign-in card would need a
 * different lockup than this square.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 40 40"
      className={cn('shrink-0', className)}
      role="img"
      aria-label="Team Accelerator"
    >
      <rect width="40" height="40" rx="9" fill="hsl(var(--brand))" />
      <g fill="hsl(var(--brand-ink))">
        <rect x="10" y="23" width="4.5" height="8" rx="1.5" opacity="0.5" />
        <rect x="17.75" y="17" width="4.5" height="14" rx="1.5" opacity="0.75" />
        <rect x="25.5" y="10" width="4.5" height="21" rx="1.5" />
      </g>
    </svg>
  )
}
